import { v4 as uuid } from 'uuid';

import { definitions } from '@luxuryescapes/contract-svc-promo';

type VoucherCondition = definitions['VoucherConditionV1'];

export function copyVoucherCondition(condition: VoucherCondition, newId = uuid()): VoucherCondition {
  return {
    id_voucher_condition: newId,
    condition_type: condition.condition_type,
    condition_value: condition.condition_value,
    condition_apply_type: condition.condition_apply_type,
    voucher_reward_ids: [...(condition.voucher_reward_ids ?? [])],
    customized_message: condition.customized_message ?? '',
  };
}
